<template>
  <div>
    <div class="py-2 px-5">
      <div class="row">
        <div v-if="!isReadOnly" class="col-4 border-right">
          <validation-observer
            :ref="contractSpecialistForm"
            v-slot="{}"
            tag="form"
          >
            <div>
              <label class="data-title mb-0">Seleccione el Especialista:</label>
              <validation-provider
                v-slot="{ errors }"
                name="contractSpecialist"
                :rules="'required'"
              >
                <custom-drop-down
                  v-model="specialistSelected"
                  custom-error-msg="El especialista es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="specialistOptions"
                  placeholder="Seleccione"
                  @input="onChangeSpecialist"
                />
              </validation-provider>
            </div>
            <div class="mt-3">
              <validation-provider v-slot="{ errors }" rules="required">
                <label class="data-title mb-0">
                  ¿Es necesaria la Supervisión?
                </label>
                <custom-radio-button
                  ref="supervisorNeedRadioButtonRef"
                  v-model="model.specialistNeedSupervisor"
                  container-class="p-0"
                  custom-error-msg="Favor marcar si o no."
                  :error="errors[0]"
                  is-inline
                  :options="specialistNeedsOptions"
                />
              </validation-provider>
            </div>
            <div v-if="model.specialistNeedSupervisor" class="mt-3">
              <label class="data-title mb-0">Seleccione el Supervisor:</label>
              <validation-provider
                v-slot="{ errors }"
                name="contractSupervisor"
                :rules="model.specialistNeedSupervisor ? 'required' : ''"
              >
                <custom-drop-down
                  v-model="supervisorSelected"
                  custom-error-msg="El supervisor es requerido."
                  :error="errors[0]"
                  fieldkey="id"
                  fieldname="name"
                  :options="specialistOptions"
                  placeholder="Seleccione"
                  @input="onChangeSupervisor"
                />
              </validation-provider>
            </div>
            <div v-if="isInterpreterDiscipline" class="mt-3">
              <validation-provider v-slot="{ errors }" rules="required">
                <label
                  class="data-title mb-0"
                  for="specialisttransportationCost"
                >
                  ¿Tiene costo de transportación?
                </label>
                <custom-radio-button
                  v-model="model.specialistNeedTransportation"
                  container-class="p-0"
                  custom-error-msg="Favor marcar si o no."
                  :error="errors[0]"
                  is-inline
                  label=""
                  name="specialisttransportationCost"
                  :options="specialistNeedsOptions"
                />
              </validation-provider>
            </div>
          </validation-observer>
          <action-button
            class="mt-4 float-right"
            i="fas fa-file-plus fa-lg"
            text="Añadir"
            variant="success"
            @click="addSpecialist"
          />
        </div>
        <div
          :class="{
            'col-8': !isReadOnly,
            'col-12': isReadOnly,
          }"
        >
          <label
            v-show="hasSpecialistsWithoutSupervision"
            class="data-title mb-1  font-weight-bold font-16"
          >
            Especialista(s) sin supervisión seleccionado(s):
          </label>
          <div class="mt-2">
            <specialist-item
              v-for="(item, idx) in specialistsWithoutSupervision"
              :key="idx"
              :is-read-only="isReadOnly"
              :is-tag="!isInterpreterDiscipline"
              :specialist="item"
              :transportation-cost="transportationCost"
              @delete="removeSpecialist"
            />
          </div>
          <div class="mt-3">
            <label
              v-show="hasSpecialistsWithSupervision"
              class="data-title mb-1 font-weight-bold font-16"
            >
              Especialista(s) con supervisión seleccionado(s):
            </label>
          </div>
          <div class="mt-2">
            <specialist-item
              v-for="(item, idx) in specialistsWithSupervision"
              :key="idx"
              :is-read-only="isReadOnly"
              :is-tag="!isInterpreterDiscipline"
              :specialist="item"
              :transportation-cost="transportationCost"
              @delete="removeSpecialist"
            />
          </div>
        </div>
      </div>
    </div>
    <div v-if="showCostTransportation" class="row pt-2">
      <div class="col-12">
        <div class="alert bg-secondary-41 rounded alert-container p-0 pt-2">
          <div class="d-flex align-items-center">
            <em
              class="fa fa-bell-exclamation h4 pl-2 ml-1 color-secondary-40"
            />
            <div
              class="
                  font-16 font-weight-normal
                  color-secondary-40
                  ml-3
                  d-flex
                  flex-column
                  mb-2
                "
            >
              <span>
                Cuando el lugar de servicio sea Escuela/Hogar en el mismo
                municipio de la oficina principal el costo es $10.
              </span>
              <span>
                Cuando el lugar de servicio sea Escuela/Hogar en otro municipio
                de la oficina principal el costo es $15.
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationProvider, ValidationObserver } from 'vee-validate';
import CustomDropDown from 'custom-drop-down';
import CustomRadioButton from 'custom-radio';
import ActionButton from 'ActionButton';
import alertMixin from '@quisit/mipe-utils/mixins/alert.mixin.js';
import SpecialistItem from './SpecialistItem.vue';
import disciplineTypes from '@/utils/constants/disciplineTypes';

export default {
  name: 'InterventionInfo',
  components: {
    ValidationObserver,
    ValidationProvider,
    ActionButton,
    CustomDropDown,
    CustomRadioButton,
    SpecialistItem,
  },
  mixins: [alertMixin],
  props: {
    specialists: {
      type: Array,
      default: () => [],
    },
    supervisors: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Array,
      default: () => [],
    },
    maxSpecialistPerContract: {
      type: Number,
      default: () => 4,
    },
    disciplineTypeId: {
      type: Number,
      default: () => 0,
    },
    isReadOnly: {
      type: Boolean,
      default: () => false,
    },
    showCostTransportation: {
      type: Boolean,
      default: () => false,
    },
    transportationCost: {
      type: Number,
      default: () => 0,
    },
    disciplineRequireSupervisor: {
      type: Boolean,
      default: () => false,
    },
  },
  data: () => ({
    model: {
      contractId: null,
      specialistId: null,
      specialistName: null,
      specialistLicenseNumber: null,
      specialtyTypeId: null,
      specialistNeedSupervisor: false,
      specialistNeedTransportation: false,
      specialistSupervisorId: null,
      specialistSupervisorFullName: null,
      ssn: null,
      hasValidLicense: true,
    },
    specialistSelected: null,
    supervisorSelected: null,
  }),
  computed: {
    disciplineRequiresSup() {
      return (
        this.model.specialistNeedSupervisor == this.disciplineRequireSupervisor
      );
    },
    contractSpecialistForm() {
      return 'contractSpecialistForm';
    },
    specialistAdded() {
      return [...this.value];
    },
    specialistOptions() {
      return [...this.specialists].filter(
        (x) => !this.specialistAdded.map((y) => y.specialistId).includes(x.id)
      );
    },
    supervisorOptions() {
      return [...this.supervisors];
    },
    specialistNeedsOptions() {
      return [
        {
          label: 'Si',
          value: true,
        },
        {
          label: 'No',
          value: false,
        },
      ];
    },
    specialistsWithSupervision() {
      return this.specialistAdded.filter((x) => x.specialistNeedSupervisor);
    },
    specialistsWithoutSupervision() {
      return this.specialistAdded.filter((x) => !x.specialistNeedSupervisor);
    },
    specialistText() {
      return (item) =>
        `${item.specialistName} - ${item.specialistLicenseNumber}`;
    },
    hasSpecialistsWithSupervision() {
      return Boolean(this.specialistsWithSupervision.length);
    },
    hasSpecialistsWithoutSupervision() {
      return Boolean(this.specialistsWithoutSupervision.length);
    },
    isInterpreterDiscipline() {
      return disciplineTypes.Interprete === this.disciplineTypeId;
    },
  },
  mounted() {
    if (this.showSubDiscipline) {
      this.getSubDisciplines();
    }
  },
  methods: {
    onChangeSpecialist(item) {
      this.model.specialistId = item?.id;
      this.model.specialistName = item?.name;
      this.model.ssn = item?.ssn;
      this.model.specialtyTypeId = item?.specialtyTypeId;
      this.model.specialistSupervisorFullName = null;
      this.model.specialistSupervisorId = null;
      this.supervisorSelected = null;
      this.$emit('select-specialist', item);
    },
    onChangeSupervisor(item) {
      this.model.specialistSupervisorFullName = item?.name;
      this.model.specialistSupervisorId = item?.id;
    },
    async addSpecialist() {
      const isValid = await this.$refs[this.contractSpecialistForm].validate();
      if (!isValid) {
        this.ShowToast(
          'Alerta',
          'Favor completar la información solicitada.',
          'error'
        );
        return;
      }
      if (this.specialistAdded.length >= this.maxSpecialistPerContract) {
        this.ShowToast(
          'Alerta',
          `Solo es permitido un máximo de ${this.maxSpecialistPerContract} especialistas por contrato.`,
          'error'
        );
        return;
      }

      const exist = this.specialistAdded.some(
        (x) => x.specialistId === this.model.specialistId
      );
      if (exist) {
        this.ShowToast('Alerta', 'El especilista ya fue agregado', 'error');
      }
      if (this.model.specialistId === this.model.specialistSupervisorId) {
        this.ShowToast(
          'Alerta',
          'El especilista y el supervisor no puede ser la misma persona.',
          'error'
        );
        return;
      } else {
        this.$emit('add', { ...this.model });
        const customRadioCurrentValue = this.$refs.supervisorNeedRadioButtonRef
          .value;
        this.model = {
          contractId: null,
          specialistId: null,
          specialistName: null,
          specialistLicenseNumber: null,
          specialtyTypeId: null,
          specialistNeedSupervisor: customRadioCurrentValue,
          specialistNeedTransportation: false,
          specialistSupervisorId: null,
          specialistSupervisorFullName: null,
          hasValidLicense: true,
        };
        this.$emit('select-specialist', {});
        this.specialistSelected = null;
        this.supervisorSelected = null;
        this.$refs[this.contractSpecialistForm].reset();
      }
    },
    removeSpecialist(item) {
      this.$emit('delete', item);
    },
  },
};
</script>
<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.specialist-item {
  border-radius: 50px;
  border: 1px solid gainsboro;
  width: fit-content;
}
.align-self-center {
  align-self: center !important;
}
.cursor-pointer {
  cursor: pointer;
}
</style>
